import { createContext, useContext } from 'react';
import type { AppConfig, Me, MeClient } from '../types';

// Daten, die überall in der Mandanten-App gebraucht werden.
export interface ClientAppValue {
  me: Me;
  // freigegebene Firmen dieses Logins (mindestens eine, sonst sieht der Mandant den Wartebildschirm)
  clients: MeClient[];
  config: AppConfig;
  // Name der Firma für Anzeigen; bei nur einer Firma oft weggelassen
  clientName(id: string): string;
}

export const ClientAppContext = createContext<ClientAppValue | null>(null);

export function useClientApp(): ClientAppValue {
  const v = useContext(ClientAppContext);
  if (!v) throw new Error('useClientApp außerhalb der Mandanten-App');
  return v;
}
